import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class BoardsTabsRoute extends Route {
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel() {
		document.body.id = 'page-desktop-view';

		return this.navigationService.initialRequestsPromise;
	}
}
